import React from "react";
import CampaignTemplate from "./LandingBootcamp";

const Campaign = () => {
  return <CampaignTemplate />;
};

export default Campaign;
